import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// @mui
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Chip,
  styled,
  Checkbox,
  ListItemText,
  Grid,
  Typography,
  Button
} from '@mui/material';

import { useTheme } from '@mui/material/styles';

// utils
import { bgBlur } from '../../utils/cssStyles';

import { CommonIcons, icons } from '../../components/common/CommonIcons';

// import { useAuthAccess } from '../../hooks/useAuthAccess';
// import { useAppContextFeatures } from '../../context/AppContext';

import MenuAccount from './MenuAccount';

import CommonTranslation from '../../components/common/CommonTranslation';
// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 80;// 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  // [theme.breakpoints.up('lg')]: {
  //   width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  // },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  // [theme.breakpoints.up('lg')]: {
  //   minHeight: HEADER_DESKTOP,
  //   padding: theme.spacing(0, 5),
  // },
}));

// ----------------------------------------------------------------------

Menu.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Menu({ onOpenNav, navMinimize, t }) {

  const theme = useTheme();

  return (
    <StyledRoot
      sx={{
        width: navMinimize ? '100%' : `calc(100% - ${NAV_WIDTH + 1}px)`,
        // backgroundColor: 'yellow'
      }}
    >
      <StyledToolbar
        sx={{
          minHeight: navMinimize ? 'auto' : HEADER_DESKTOP,
          padding: navMinimize ? 'auto' : theme.spacing(0, 5),
        }}
      >
        <Stack
          display={"flex"}
          flexDirection="row"
          justifyContent={"space-between"}
          alignItems="center"
          spacing={{
            // xs: 0.5,
            // sm: 1,
          }}
          sx={{
            // backgroundColor: 'red',
            // flex: 1
            p: 0.5
          }}
          flexGrow={1}
        >
          <Grid container alignItems="center" direction="row" spacing={0}>
            <Grid item xs={3} sm={3} md={6}>
              <Box
                sx={{
                  flex: 1,
                }}
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-start"}
                alignItems={"center"}
              >
                <IconButton
                  onClick={onOpenNav}
                  sx={{
                    // mr: 1,
                    p: 0,
                    width: 45,
                    height: 45,
                    color: 'text.primary',
                    // display: { lg: 'none' },
                    display: navMinimize ? 'block' : 'none'
                  }}
                >
                  <CommonIcons name={icons.burger} sx={{ width: 40, height: 40 }} />
                </IconButton>

              </Box>
            </Grid>
            <Grid item xs={9} sm={9} md={6}>
              <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                sx={{
                  // flex: 1,
                  // backgroundColor: 'green',
                  // alignSelf: 'flex-end'
                }}
                textAlign={"right"}
              >
                <Box
                  sx={{
                    mr: 0
                  }}
                >
                  <CommonTranslation />
                </Box>
                <MenuAccount
                  t={t}
                />
              </Box>
            </Grid>
          </Grid>

        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
